import React, { useState, useMemo, useDeferredValue, useEffect } from 'react'
import Dropdown from 'meinian-package/src/baseComponent/dropdown'
import { NewSearch } from 'meinian-package/src/baseComponent/input'
import replaceHandle from 'meinian-package/src/common/replaceHandle'
import { useDeepCompareEffect } from 'ahooks'
import { Icon } from 'meinian-package/src/component'
import classNames from 'classnames'
import DropDownClearIcon from 'meinian-package/src/baseComponent/dropDownClearIcon'
import styles from './index.module.less'

const defaultConvert = (result) => {
  return result.map(m => ({ label: m.nickName, value: m.userId }))
}
export enum SEARCH_TYPE{
  REQUEST='REQUEST',
  NAME='NAME',
  SPECIAL_REQUEST= 'SPECIAL_REQUEST'
}

type IAddPanelSelect = {
  panelLabel:string,
  label?:string,
  loading?:boolean,
  options:Array<any>,
  afterOption?:any,
  value:Array<any>,
  onChange:any,
  style?:React.CSSProperties,
  convert:any,
  onSearch?:any,
  searchText?:string,
  type?:SEARCH_TYPE
}

export default ({
  panelLabel,
  loading = false,
  label = '',
  options,
  afterOption = undefined,
  value = [],
  onChange,
  style,
  convert = defaultConvert,
  onSearch,
  searchText,
  type = SEARCH_TYPE.NAME
}:IAddPanelSelect) => {
  const [values, setValues] = useState(value)
  const [option, setOptions] = useState([])
  const [visible, setVisible] = useState(false)
  const [keywords, setKeyWords] = useState(searchText)
  const deferredKeywords = useDeferredValue(keywords)

  useEffect(() => {
    setKeyWords(searchText)
  }, [searchText])

  useDeepCompareEffect(() => {
    onInit()
  }, [options, value])

  const onInit = async () => {
    const _result = convert(options)
    const _option = afterOption ? afterOption(_result) : _result
    setOptions(_option)
    if (type === SEARCH_TYPE.NAME) {
      const _values = _option.filter(item => value.some(m => m === item.value))
      setValues(_values)
    }
    if (type === SEARCH_TYPE.SPECIAL_REQUEST) {
      setValues(value)
    }
  }

  const _option = useMemo(() => {
    if (type === SEARCH_TYPE.NAME) {
      return option.filter(item => (deferredKeywords ? item.label.includes(deferredKeywords) : true))
    }
    return option
  }, [deferredKeywords, option])

  const _onChange = () => {
    onChange?.(values.map(item => item.value), values)
    setValues(pre => [...pre])
  }
  const content = (<div className={styles.userFilterContent} onClick={(e) => e.stopPropagation()}>
    <div className="userFilterContentLeft">
      <div className="userFilterContentLeftTitle">已选择</div>
      {
        values.length ? <div className="userFilterContentLeftList">
          {
          values.map((item, index) => <div key={item.value} className="userFilterContentLeftListItem">
            <div className="userFilterContentLeftListItemText">{item.label}</div>
            <Icon
              type="m-guanbi"
              className="clear-icon"
              onClick={(e) => {
                e.stopPropagation()
                values.splice(index, 1)
                _onChange()
              }}
            />
          </div>)
        }
        </div> : <div className="userFilterContentLeftEmpty">暂未选择{panelLabel}</div>
      }
    </div>
    <div className="userFilterContentRight">
      <div className="userFilterContentRightTitle">全部{panelLabel}</div>
      <NewSearch
        value={keywords}
        onClear={() => {
          setKeyWords('')
          onSearch('')
        }}
        placeholder="请输入关键词搜索"
        onChange={(val) => {
          onSearch?.(val)
          setKeyWords(val)
        }}
        wrapStyle={{ marginTop: '12px', borderRadius: '6px', width: '100%' }}
      />
      <div className="userFilterContentRightList">
        {
          _option.length ? _option.map(item => <div className="userFilterContentRightListItem">
            {
              type === SEARCH_TYPE.NAME ? <div
                className="userFilterContentRightListItemText text-overflow"
                dangerouslySetInnerHTML={{ __html: replaceHandle(item.label, deferredKeywords) }}
              /> : <div
                className="userFilterContentRightListItemText text-overflow"
              >{item.label}</div>
            }
            <div
              onClick={(e) => {
                e.stopPropagation()
                if (!values.some(m => m.value === item.value)) {
                  values.push(item)
                  _onChange()
                }
              }}
              className={classNames('userFilterContentRightListItemIcon', { active: values.some(m => m.value === item.value) })}
            >
              <Icon type={`${values.some(m => m.value === item.value) ? 'm-xiaoyan' : 'm-tianjia_miaobian'}`} />
            </div>
          </div>) : <div style={{ color: 'var(--m-text-3)', textAlign: 'center', marginTop: '20px' }}>{loading ? '搜索中' : '搜索无结果'}</div>
        }
      </div>
    </div>
  </div>)

  return <Dropdown
    placement="bottomLeft"
    trigger="click"
    overlayClassName=""
    overlay={content}
    open={visible}
    getPopupContainer={() => document.body}
    onOpenChange={vis => setVisible(vis)}
  >

    <div className={styles.userFilter} style={style}>
      <div className={classNames('userFilterLabelText dropDownClearIcon', { clear: values.length })}>
        {
        label && <div className="userFilterLabel">{label}</div>
      }
        <div className="userFilterLabelValue">
          <DropDownClearIcon
            visible={visible}
            onClear={() => {
              values.length = 0
              _onChange()
            }}
          >
            {
          values.length ? <div className="userFilterLabelValueNum">
            {values.length}
          </div> : <span className="userFilterLabelValueAllowClearText">
            不限
          </span>
        }
          </DropDownClearIcon>
        </div>
      </div>
    </div>
  </Dropdown>
}
